/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import Map, { Marker } from "react-map-gl/maplibre";
import "maplibre-gl/dist/maplibre-gl.css";
import moment from "moment";
import "moment-timezone";
import { toast } from "react-toastify";

import BailoDotSimpleReportsCard from "./components/BailoDotSimpleReportsCard";
import siteAnalyticsService from "../../services/siteAnalyticsService";
import Text from "../../components/Text";
import reportService from "../../services/reportService";
import { getConfirmStatus, CONFIRM_COLORS, CONFIRM_DICT_KEYS } from "../../utils/confirmationStatus";
import { fixUtf8 } from "../../utils/fixUtf8";
import { injectRichStyles } from "../../components/RichTextEditor";

const { imageUrl } = require("../../styles/images/mapdotImgUrl/imageUrl");

const BAILO_MARKER =
  "https://res.cloudinary.com/dklijqv8g/image/upload/v1624803083/bailo_marker2_bilow4.png";

const ACCENT = "#4e6ac5";
const SECTION_BG = "#f4f5f9";

const Section = ({ title, icon, children }) => (
  <div style={{ marginBottom: 12 }}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        background: ACCENT,
        padding: "9px 14px",
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
      }}
    >
      {icon && (
        <i
          className={`feather ${icon}`}
          style={{ color: "#fff", marginRight: 8, fontSize: 14 }}
        />
      )}
      <span
        style={{
          color: "#fff",
          fontWeight: 700,
          fontSize: 13,
          letterSpacing: 0.3,
          textTransform: "uppercase",
          fontFamily: '"Montserrat", sans-serif',
        }}
      >
        {title}
      </span>
    </div>
    <div
      style={{
        background: "#fff",
        padding: "12px 14px",
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
      }}
    >
      {children}
    </div>
  </div>
);

class MapdotPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      reportMessage: "",
      reportLastConfirmation: "",
      mapdotId: props.mapdot ? props.mapdot._id : "",
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mapdot !== this.props.mapdot) {
      this.setState({ mapdotId: this.props.mapdot._id });
    }
  }

  handleShow = () => {
    const { mapdot } = this.props;
    siteAnalyticsService.track({
      eventType: "venue_detail_view",
      venueName: mapdot.title || mapdot.publicName || "",
      venueId: String(mapdot._id),
      category: mapdot.categoryIdName || null,
    });
    this.setState({ show: true });
  };
  handleClose = () => this.setState({ show: false });
  handleChange = (e) => this.setState({ reportMessage: e.target.value });

  handleReportConfirm = async () => {
    const { mapdot } = this.props;
    const date = moment().format("YYYY-MM-DD");
    await reportService
      .addReportConfirmAllUsers(date, mapdot._id)
      .then(() => {
        toast.success("👍 Confirmed!");
        this.setState({ reportLastConfirmation: moment(date).format("DD-MM-YYYY") });
      })
      .catch(() => toast.error("😧 ERROR! try again"));
  };

  handleReportError = async () => {
    const { reportMessage } = this.state;
    const { mapdot } = this.props;
    if (!mapdot?._id) { toast.error("😧 Error: No mapdot ID."); return; }
    if (!reportMessage) { toast.error("El mensaje de reporte está vacío."); return; }
    const date = moment().format("YYYY-MM-DD");
    try {
      await reportService.addReportErrorAllUsers(reportMessage, date, mapdot._id);
      toast.success("👍 Confirmed!");
      this.setState({ reportMessage: "" });
    } catch (e) {
      toast.error("😧 ERROR! try again");
    }
  };

  resolveImgUrl(mapdot) {
    try {
      if (mapdot && mapdot.mapdotImgUrl) return mapdot.mapdotImgUrl;
      const cat = mapdot && mapdot.categoryIdName;
      if (cat === "class" || cat === "school" || cat === "teacher") {
        return (imageUrl.find((x) => x.name === "class") || {}).src || "";
      }
      if (cat === "radio" || cat === "musician") {
        return (imageUrl.find((x) => x.name === "radio") || {}).src || "";
      }
      return (imageUrl.find((x) => x.name === "milonga") || {}).src || "";
    } catch (e) {
      return "";
    }
  }

  renderModalContent() {
    const { mapdot } = this.props;
    const { reportMessage, reportLastConfirmation } = this.state;
    const dictionary = (this.props.lang && this.props.lang.dictionary) || {};

    const latitude = mapdot?.coordinatesLatLong?.Latitude || mapdot?.coordinatesLatLong?.lat || null;
    const longitude = mapdot?.coordinatesLatLong?.Longitude || mapdot?.coordinatesLatLong?.lng || null;
    const imgSrc = this.resolveImgUrl(mapdot);
    const displayTitle = fixUtf8(
      mapdot.categoryIdName !== "teacher" && mapdot.categoryIdName !== "musician"
        ? (mapdot.title || mapdot.publicName)
        : (mapdot.publicName || mapdot.title)
    );

    const hasContact =
      (mapdot.phoneNr && mapdot.phoneNr !== "") ||
      (mapdot.emailMapdot && mapdot.emailMapdot !== "") ||
      (mapdot.website && mapdot.website !== "");

    const lastConfirmedDate = mapdot.isMapdotConfirmed
      ? moment(mapdot.isMapdotConfirmed, "YYYY-MM-DD")
      : null;
    const isRecentConfirmation =
      lastConfirmedDate && lastConfirmedDate.isAfter(moment().subtract(3, "months"));
    const lastConfirmDisplay =
      reportLastConfirmation ||
      (isRecentConfirmation ? lastConfirmedDate.format("DD-MM-YYYY") : null);

    const confirmStatus = getConfirmStatus(mapdot.isMapdotConfirmed);
    const confirmDotColor = CONFIRM_COLORS[confirmStatus];
    const confirmDotTitle = dictionary[CONFIRM_DICT_KEYS[confirmStatus]] || confirmStatus;

    const generalItems = [
      mapdot.danceIdName && { icon: "icon-music", label: dictionary.dance, value: mapdot.danceIdName },
      mapdot.artistType && { icon: "icon-star", label: dictionary.artistType, value: mapdot.artistType },
      mapdot.frequency && { icon: "icon-repeat", label: dictionary.frequency, value: dictionary[mapdot.frequency] || mapdot.frequency },
      mapdot.day && { icon: "icon-calendar", label: dictionary.day, value: dictionary[mapdot.day] || mapdot.day },
      mapdot.timeStart && { icon: "icon-clock", label: dictionary.timeStart, value: mapdot.timeStart },
      mapdot.timeEnd && { icon: "icon-clock", label: dictionary.timeEnd, value: mapdot.timeEnd },
      mapdot.price && { icon: "icon-tag", label: dictionary.price, value: mapdot.price },
    ].filter(Boolean);

    return (
      <>
        {/* Hero image */}
        <div style={{ borderRadius: "10px 10px 0 0", overflow: "hidden" }}>
          <img
            src={imgSrc}
            alt={displayTitle}
            style={{ width: "100%", height: 200, objectFit: "cover", display: "block" }}
          />
        </div>

        {/* Title box */}
        <div style={{ background: "#1e2d4d", padding: "16px 20px", textAlign: "center" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
            <h3
              style={{
                color: "#fff",
                margin: 0,
                fontWeight: 700,
                fontSize: 20,
                fontFamily: '"Montserrat", sans-serif',
              }}
            >
              {displayTitle}
            </h3>
            <span
              title={confirmDotTitle}
              style={{
                flexShrink: 0,
                width: 12,
                height: 12,
                borderRadius: "50%",
                background: confirmDotColor,
                border: "2px solid rgba(255,255,255,0.5)",
                boxShadow: `0 0 6px ${confirmDotColor}99`,
                display: "inline-block",
              }}
            />
          </div>
          {mapdot.categoryIdName !== "teacher" && mapdot.categoryIdName !== "musician" && (
            <>
              {mapdot.address && (
                <p style={{ color: "rgba(255,255,255,0.75)", margin: "6px 0 0", fontSize: 13 }}>
                  {fixUtf8(mapdot.address)}
                </p>
              )}
              {mapdot.city && (
                <p style={{ color: "rgba(255,255,255,0.75)", margin: "2px 0 0", fontSize: 13 }}>
                  {fixUtf8(mapdot.city)}{mapdot.country ? `, ${fixUtf8(mapdot.country)}` : ""}
                </p>
              )}
            </>
          )}
        </div>

        {/* Content */}
        <div style={{ background: SECTION_BG, padding: "12px 12px 16px" }}>

          {/* Description */}
          {mapdot.description && mapdot.description !== "" && (
            <Section title={dictionary.description || "Description"} icon="icon-file-text">
              {/<[a-z][\s\S]*>/i.test(mapdot.description) ? (
                <div
                  style={{ fontSize: 13, color: "#333", lineHeight: 1.6 }}
                  dangerouslySetInnerHTML={{ __html: injectRichStyles(fixUtf8(mapdot.description)) }}
                />
              ) : (
                <p style={{ fontSize: 13, color: "#333", lineHeight: 1.6, margin: 0 }}>
                  {fixUtf8(mapdot.description)}
                </p>
              )}
            </Section>
          )}

          {/* Contact */}
          {hasContact && (
            <Section title={dictionary.contactUs || "Contact"} icon="icon-phone">
              {[
                mapdot.phoneNr && { icon: "icon-phone", value: mapdot.phoneNr },
                mapdot.emailMapdot && { icon: "icon-mail", value: mapdot.emailMapdot },
                mapdot.website && { icon: "icon-globe", value: mapdot.website, link: true },
              ]
                .filter(Boolean)
                .map((item, i, arr) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 0",
                      borderBottom: i < arr.length - 1 ? "1px solid #f0f0f0" : "none",
                    }}
                  >
                    <i
                      className={`feather ${item.icon}`}
                      style={{ color: ACCENT, fontSize: 16, marginRight: 10, flexShrink: 0 }}
                    />
                    {item.link ? (
                      <a href={item.value} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: "#333" }}>
                        {item.value}
                      </a>
                    ) : (
                      <span style={{ fontSize: 13, color: "#333" }}>{item.value}</span>
                    )}
                  </div>
                ))}
            </Section>
          )}

          {/* General — hidden for teacher and school */}
          {mapdot.categoryIdName !== "teacher" && mapdot.categoryIdName !== "school" && generalItems.length > 0 && (
            <Section title="General" icon="icon-list">
              {generalItems.map((item, i, arr) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 0",
                    borderBottom: i < arr.length - 1 ? "1px solid #f0f0f0" : "none",
                  }}
                >
                  <i
                    className={`feather ${item.icon}`}
                    style={{ color: ACCENT, fontSize: 16, marginRight: 10, flexShrink: 0 }}
                  />
                  <span style={{ fontSize: 13, color: "#333" }}>
                    <strong>{item.label}:</strong> {item.value}
                  </span>
                </div>
              ))}
            </Section>
          )}

          {/* Teacher Schedule */}
          {mapdot.categoryIdName === "teacher" && mapdot.teacherSchedule?.length > 0 && (
            <Section title={dictionary.sectionTeacherSchedule || "Teaching schedule"} icon="icon-calendar">
              <table style={{ width: "100%", fontSize: 13, borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f4f5f9" }}>
                    <th style={{ padding: "6px 8px", textAlign: "left" }}>{dictionary.schoolName || "School"}</th>
                    <th style={{ padding: "6px 8px", textAlign: "left" }}>{dictionary.day}</th>
                    <th style={{ padding: "6px 8px", textAlign: "left" }}>{dictionary.timeStart}</th>
                    <th style={{ padding: "6px 8px", textAlign: "left" }}>{dictionary.timeEnd}</th>
                  </tr>
                </thead>
                <tbody>
                  {mapdot.teacherSchedule.map((slot, i) => (
                    <tr key={i} style={{ borderTop: "1px solid #f0f0f0" }}>
                      <td style={{ padding: "6px 8px" }}>{slot.schoolName || "—"}</td>
                      <td style={{ padding: "6px 8px" }}>{dictionary[slot.day] || slot.day}</td>
                      <td style={{ padding: "6px 8px" }}>{slot.timeStart}</td>
                      <td style={{ padding: "6px 8px" }}>{slot.timeEnd}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Section>
          )}

          {/* Class Schedule */}
          {mapdot.categoryIdName === "school" && mapdot.classSchedule?.length > 0 && (
            <Section title={dictionary.sectionClassSchedule || "Class schedule"} icon="icon-calendar">
              <table style={{ width: "100%", fontSize: 13, borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f4f5f9" }}>
                    <th style={{ padding: "6px 8px", textAlign: "left" }}>{dictionary.day}</th>
                    <th style={{ padding: "6px 8px", textAlign: "left" }}>{dictionary.timeStart}</th>
                    <th style={{ padding: "6px 8px", textAlign: "left" }}>{dictionary.timeEnd}</th>
                    <th style={{ padding: "6px 8px", textAlign: "left" }}>{dictionary.classLevel}</th>
                    <th style={{ padding: "6px 8px", textAlign: "left" }}>{dictionary.classTeacherName}</th>
                  </tr>
                </thead>
                <tbody>
                  {mapdot.classSchedule.map((slot, i) => (
                    <tr key={i} style={{ borderTop: "1px solid #f0f0f0" }}>
                      <td style={{ padding: "6px 8px" }}>{dictionary[slot.day] || slot.day}</td>
                      <td style={{ padding: "6px 8px" }}>{slot.timeStart}</td>
                      <td style={{ padding: "6px 8px" }}>{slot.timeEnd}</td>
                      <td style={{ padding: "6px 8px" }}>{slot.classLevel}</td>
                      <td style={{ padding: "6px 8px" }}>{slot.teacherName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Section>
          )}

          {/* Map */}
          {latitude && longitude && (
            <Section title="Map" icon="icon-map-pin">
              <div style={{ height: 200, borderRadius: 8, overflow: "hidden", marginBottom: 10 }}>
                <Map
                  initialViewState={{ longitude, latitude, zoom: 15 }}
                  style={{ width: "100%", height: "100%" }}
                  mapStyle="https://tiles.openfreemap.org/styles/liberty"
                  scrollZoom={false}
                >
                  <Marker longitude={longitude} latitude={latitude} anchor="bottom">
                    <img src={BAILO_MARKER} style={{ width: 35, height: 35 }} alt="marker" />
                  </Marker>
                </Map>
              </div>
              {mapdot.categoryIdName !== "teacher" &&
                mapdot.categoryIdName !== "radio" &&
                mapdot.categoryIdName !== "musician" && (
                  <a
                    href={`https://maps.google.com?q=${latitude},${longitude}`}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-sm btn-outline-primary w-100"
                  >
                    <i className="feather icon-navigation mr-1" />
                    <Text tid="goGoogle" />
                  </a>
                )}
            </Section>
          )}

          {/* Reports */}
          <Section title={dictionary.reportInfo || "Report"} icon="icon-flag">
            <p style={{ fontSize: 12, color: "#666", marginBottom: 8 }}>
              {dictionary.reportLastConfirmation}:{" "}
              <strong>{lastConfirmDisplay || dictionary.reportNoConfirmation}</strong>
            </p>
            <BailoDotSimpleReportsCard
              mapdot={mapdot}
              reportMessage={reportMessage}
              handleChange={this.handleChange}
              handleReportError={this.handleReportError}
              handleReportConfirm={this.handleReportConfirm}
            />
          </Section>
        </div>
      </>
    );
  }

  render() {
    const { mapdot } = this.props;
    const { show } = this.state;

    const displayTitle =
      mapdot.categoryIdName !== "teacher" && mapdot.categoryIdName !== "musician"
        ? (mapdot.title || mapdot.publicName)
        : (mapdot.publicName || mapdot.title);

    const ownerId = mapdot.ownerMapdot?._id || mapdot.ownerMapdot;
    const isOwner = ownerId && ownerId.toString() === this.props.auth?.user?.id;

    const handleTitleClick = () => {
      if (isOwner) {
        this.props.history.push({
          pathname: `/dashboard/bailo-dots/${(mapdot.title || mapdot.publicName || mapdot._id).toString().toLowerCase()}`,
          state: `${mapdot._id}`,
        });
      } else {
        this.handleShow();
      }
    };

    return (
      <div>
        <h5
          onClick={handleTitleClick}
          style={{ cursor: "pointer", color: ACCENT, fontWeight: "bold", margin: 0 }}
        >
          {displayTitle}
        </h5>

        <Modal show={show} onHide={this.handleClose} centered size="lg">
          <Modal.Body style={{ padding: 0, borderRadius: 10, overflow: "hidden" }}>
            {show && this.renderModalContent()}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              <Text tid="closeButton" />
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  lang: state.lang,
  layout: state.layout,
});

export default withRouter(connect(mapStateToProps)(MapdotPopup));
